var app;

app = window.App || (window.App = {});

app.CostAccountingCalculator = (function() {
  function CostAccountingCalculator() {}

  CostAccountingCalculator.prototype.updateValues = function() {
    $('#aufwand_ertrag_ko_re').html(this.formatMoney(this.aufwandErtragKoRe()));
    $('#gemeinkosten').html(this.formatMoney(this.gemeinkosten()));
    $('#kostentraeger').html(this.formatMoney(this.kostentraeger()));
    return $('#control_value').html(this.formatMoney(this.kontrolle()));
  };

  CostAccountingCalculator.prototype.bind = function() {
    var self;
    self = this;
    return $(document).on('keyup change', '#cost_accounting_record_aufwand_ertrag_fibu, #cost_accounting_record_abgrenzung_dachorganisation, #cost_accounting_record_abgrenzung_fibu, #cost_accounting_record_raeumlichkeiten, #cost_accounting_record_verwaltung, #cost_accounting_record_beratung, #cost_accounting_record_medien_und_publikationen, #cost_accounting_record_treffpunkte, #cost_accounting_record_blockkurse, #cost_accounting_record_tageskurse, #cost_accounting_record_jahreskurse, #cost_accounting_record_lufeb, #cost_accounting_record_mittelbeschaffung', function(e) {
      return self.updateValues();
    });
  };

  CostAccountingCalculator.prototype.aufwandErtragKoRe = function() {
    return this.floatVal('#cost_accounting_record_aufwand_ertrag_fibu') - this.floatVal('#cost_accounting_record_abgrenzung_dachorganisation') - this.abgrenzungFibu();
  };

  CostAccountingCalculator.prototype.total = function() {
    return this.gemeinkosten() + this.kostentraeger();
  };

  CostAccountingCalculator.prototype.gemeinkosten = function() {
    return this.floatVal('#cost_accounting_record_raeumlichkeiten') + this.floatVal('#cost_accounting_record_verwaltung') + this.floatVal('#cost_accounting_record_mittelbeschaffung');
  };

  CostAccountingCalculator.prototype.kostentraeger = function() {
    return this.floatVal('#cost_accounting_record_beratung') + this.floatVal('#cost_accounting_record_medien_und_publikationen') + this.floatVal('#cost_accounting_record_treffpunkte') + this.floatVal('#cost_accounting_record_blockkurse') + this.floatVal('#cost_accounting_record_tageskurse') + this.floatVal('#cost_accounting_record_jahreskurse') + this.floatVal('#cost_accounting_record_lufeb');
  };

  CostAccountingCalculator.prototype.kontrolle = function() {
    return this.total() - this.aufwandErtragKoRe();
  };

  CostAccountingCalculator.prototype.abgrenzungFibu = function() {
    if (this.abgrenzungFactor()) {
      return this.floatVal('#cost_accounting_record_aufwand_ertrag_fibu') * this.abgrenzungFactor();
    } else {
      return this.floatVal('#cost_accounting_record_abgrenzung_fibu');
    }
  };

  CostAccountingCalculator.prototype.abgrenzungFactor = function() {
    var factor;
    factor = $('#aufwand_ertrag_ko_re').data('abgrenzung-factor');
    if (factor) {
      return parseFloat(factor);
    } else {
      return null;
    }
  };

  CostAccountingCalculator.prototype.floatVal = function(field) {
    var float;
    float = parseFloat($(field).val() || 0);
    if (isNaN(float)) {
      return 0;
    } else {
      return float;
    }
  };

  CostAccountingCalculator.prototype.formatMoney = function(value) {
    return value.toFixed(2) + ' CHF';
  };

  return CostAccountingCalculator;

})();

new app.CostAccountingCalculator().bind();
